/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateThreedimodel
 */
export interface CreateThreedimodel {
  /**
   * Try to inherit simulation templates from previous threedimodel (in case of regenerate)
   */
  inheritFromPreviousThreedimodel?: boolean;
  /**
   * Try to inherit simulation templates from previous revision
   */
  inheritFromPreviousRevision?: boolean;
}

/**
 * Check if a given object implements the CreateThreedimodel interface.
 */
export function instanceOfCreateThreedimodel(value: object): value is CreateThreedimodel {
  return true;
}

export function CreateThreedimodelFromJSON(json: any): CreateThreedimodel {
  return CreateThreedimodelFromJSONTyped(json, false);
}

export function CreateThreedimodelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateThreedimodel {
  if (json == null) {
    return json;
  }
  return {
    inheritFromPreviousThreedimodel:
      json["inherit_from_previous_threedimodel"] == null
        ? undefined
        : json["inherit_from_previous_threedimodel"],
    inheritFromPreviousRevision:
      json["inherit_from_previous_revision"] == null
        ? undefined
        : json["inherit_from_previous_revision"],
  };
}

export function CreateThreedimodelToJSON(json: any): CreateThreedimodel {
  return CreateThreedimodelToJSONTyped(json, false);
}

export function CreateThreedimodelToJSONTyped(
  value?: CreateThreedimodel | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    inherit_from_previous_threedimodel: value["inheritFromPreviousThreedimodel"],
    inherit_from_previous_revision: value["inheritFromPreviousRevision"],
  };
}
